$('.homepage .menu a').each(function(){
  var $this = $(this);

  $this.on('click', function(e){
    e.preventDefault();

    $('li', '.menu').removeClass('active');
    $(this).parent().addClass('active');
  });
});